import axiosInstance from "@/lib/axiosInstance";
import { PriceStore } from "@/types/pricesTypes";
import { mockHomeAnalytics } from "@/constants/homeAnalytics";
import { create } from "zustand";
import { persist, PersistOptions } from "zustand/middleware";

export const usePricesStore = create<PriceStore>()(
    persist(
        (set) => ({
            prices: null,
            homeAnalytics: null,

            getPricesAndAnalytics: async () => {
                try {

                    const res = await axiosInstance.get("/plans");

                    const prices = res.data.data.filter((p: { type: string; }) => p.type === "individuals")

                    set({
                        prices
                    });

                    const useMock = process.env.NEXT_PUBLIC_USE_MOCK_HOME_ANALYTICS === 'true'
                    if (useMock) {
                        set({ homeAnalytics: mockHomeAnalytics });
                    } else {
                        const res2 = await axiosInstance.get("/analytics/home");
                        set({ homeAnalytics: res2.data });
                    }

                } catch (error) {
                    console.log(error);
                }
            }
        }),
        {
            name: "price-storage"
        } as PersistOptions<PriceStore>
    )
);
